import script from "./moNoticeDetailPop.vue?vue&type=script&setup=true&name=moNoticeDetailPop&lang=js"
export * from "./moNoticeDetailPop.vue?vue&type=script&setup=true&name=moNoticeDetailPop&lang=js"

const __exports__ = script;

export default __exports__